/* eslint-disable object-curly-newline */
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  setActionBarCountry({ commit }, { country }) {
    if (country && country.code) {
      return storeActionCommit(commit, 'setActionBarCountry')(country.code);
    }
  },

  setActionBarTax({ commit }, { tax }) {
    return storeActionCommit(commit, 'setActionBarTax')(tax.code);
  },
};
